<template>
  <div class="wrapper">
    <div class="fourthWrapper" v-if="!isIpad">
      <template v-for="(item, index) in list" :key="index">
        <div class="page">
          <router-link
            :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          >
            <ImageContainer
              :src="item.image.medium"
              :thumb="item.image.thumbnail"
              :alt="item.title"
              class="img"
            />
            <div class="content">
              <h1>{{ item.title }}</h1>
              <h2>{{ item.sub_category.name }}</h2>
              <h3>
                {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
              </h3>
              <p v-if="!isIpad">{{ item.brief }}</p>
            </div>
          </router-link>
        </div>
      </template>
    </div>
    <div class="fourthIpad" v-if="isIpad">
      <div class="ipad-top">
        <div class="ipad-left">
          <template v-for="(item, index) in list.slice(0, 5)" :key="index">
            <router-link
              :to="
                $i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })
              "
              class="ipad-content"
            >
              <h2>{{ item.sub_category.name }}</h2>
              <h1>{{ item.title }}</h1>
              <h3>
                {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
              </h3>
            </router-link>
            <div class="border-container" v-if="index !== 4">
              <div class="border"></div>
            </div>
          </template>
        </div>
        <div class="ipad-right">
          <template v-for="(item, index) in list.slice(5, 7)" :key="index">
            <router-link
              :to="
                $i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })
              "
              class="ipad-content"
            >
              <ImageContainer
                v-if="isIpad"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
                class="img"
              />
              <h2>{{ item.sub_category.name }}</h2>
              <h1>{{ item.title }}</h1>
              <h3>
                {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
              </h3>
            </router-link>
          </template>
        </div>
      </div>
      <div class="ipad-bottom">
        <template v-for="(item, index) in list.slice(7, 8)" :key="index">
          <div class="ipad-bottom-cont">
            <router-link to="">
              <ImageContainer
                v-if="isIpad"
                :src="item.image.medium"
                :thumb="item.image.thumbnail"
                :alt="item.title"
                class="img"
              />
              <div class="ipad-content">
                <h2>{{ item.sub_category.name }}</h2>
                <h3>
                  {{ handleDate(item.pub_date) }},
                  {{ handleTime(item.pub_date) }}
                </h3>
                <h1>{{ item.title }}</h1>
              </div>
            </router-link>
          </div>
        </template>
      </div>
    </div>
    <div class="fourthMobile" v-if="isMobile">
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        class="mob-top"
        v-for="(item, index) in list.slice(0, 2)"
        :key="index"
      >
        <ImageContainer
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
          class="img"
        />
        <div class="mob-content">
          <h2>{{ item.sub_category.name }}</h2>
          <h1>{{ item.title }}</h1>
          <h3>
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h3>
        </div>
      </router-link>
      <div class="mob-mid">
        <router-link
          :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
          v-for="(item, index) in list.slice(2, 6)"
          :key="index"
        >
          <div class="mid-content">
            <h2>{{ item.sub_category.name }}</h2>
            <h1>{{ item.title }}</h1>
            <h3>
              {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
            </h3>
          </div>

          <div class="mob-border" v-if="index !== 3"></div>
        </router-link>
      </div>
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        class="mob-top"
        v-for="(item, index) in list.slice(6, 8)"
        :key="index"
      >
        <ImageContainer
          :src="item.image.medium"
          :thumb="item.image.thumbnail"
          :alt="item.title"
          class="img"
        />
        <div class="mob-content">
          <h2>{{ item.sub_category.name }}</h2>
          <h1>{{ item.title }}</h1>
          <h3>
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h3>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  components: {
    ImageContainer,
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const isIpad = ref();
    const isMobile = ref();

    const handleResize = () => {
      isIpad.value = window.innerWidth <= 1366;
      isMobile.value = window.innerWidth <= 1366;
    };

    if (typeof window !== "undefined") {
      isIpad.value = window.innerWidth <= 1366;
      isMobile.value = window.innerWidth <= 1366;
      window.addEventListener("resize", handleResize);
    }

    onBeforeUnmount(() => {
      if (typeof window !== "undefined") {
        window.removeEventListener("resize", handleResize);
      }
    });

    return {
      ...useFormatter(),
      isIpad,
      isMobile,
    };
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  .fourthWrapper {
    display: grid;
    grid-template-areas:
      "content1 content2 content3 content4"
      "content5  content5  content6 content6"
      "content7  content7  content8 content8";
    background: var(--second-bg);
    gap: 1vw;
    h1 {
      font-size: 1.25vw;
      line-height: 1.467vw;
    }
    p {
      font-size: 0.938vw;
      line-height: 1.25vw;
      font-weight: 500;
      display: block; /* Fallback for non-webkit */
      display: -webkit-box;
      -webkit-line-clamp: 3; /* if you change this, make sure to change the fallback line-height and height */
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 3.606vw;
    }
    h2 {
      font-size: 0.833vw;
      line-height: 1.042vw;
    }
    h3 {
      font-size: 0.833vw;
      line-height: 1.042vw;
    }
    .page {
      display: flex;
      // padding: 1.5vw;
      flex-direction: column;
      &:nth-child(1) {
        grid-area: content1;
      }
      &:nth-child(2) {
        grid-area: content2;
      }
      &:nth-child(3) {
        grid-area: content3;
      }
      &:nth-child(4) {
        grid-area: content4;
      }
      &:nth-child(5) {
        grid-area: content5;
      }
      &:nth-child(6) {
        grid-area: content6;
      }
      &:nth-child(7) {
        grid-area: content7;
      }
      &:nth-child(8) {
        grid-area: content8;
      }
      /* style */
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3),
      &:nth-child(4) {
        display: grid;
        grid-template-areas:
          "img"
          "top-content";
        margin-bottom: 2.344vw;
        width: 21.615vw;
        // grid-template-rows: 14.01vw 13vw;
        margin-left: 1.3vw;
        .img {
          width: 21.615vw;
          height: 14.01vw;
          grid-area: img;
          margin-bottom: 1vw;
        }
        .content {
          grid-area: top-content;
          display: grid;
          grid-template-areas:
            "title title"
            "category date"
            "brief brief";
          grid-gap: 0.521vw;
          h1 {
            grid-area: title;
            font-weight: 700;
            color: var(--black);
          }
          h2 {
            grid-area: category;
            font-weight: 500;
            color: var(--category);
          }
          h3 {
            grid-area: date;
            font-weight: 500;
            color: var(--category);
          }
          p {
            grid-area: brief;
            font-weight: 500;
            color: var(--black);
          }
        }
      }
      &:nth-child(5),
      &:nth-child(6),
      &:nth-child(7),
      &:nth-child(8) {
        width: 47.708vw;
        position: relative;
        background: var(--black);
        margin-bottom: 2.083vw;
        cursor: pointer;
        margin-left: 1.3vw;

        .img {
          width: 47.708vw;
          height: 20.573vw;
          opacity: 0.5;
        }
        .content {
          position: absolute;
          top: 0;
          width: 22.156vw;
          display: grid;
          grid-template-areas:
            "title title"
            "category date"
            "brief brief";
          padding-top: 2.083vw;
          padding-left: 2.083vw;
          pointer-events: none;

          h1 {
            grid-area: title;
            font-weight: 700;
          }
          h2 {
            grid-area: category;
            font-weight: 500;
            margin-bottom: 0.781vw;
            margin-top: 0.781vw;
          }
          h3 {
            grid-area: date;
            font-weight: 500;
            margin-bottom: 0.781vw;
            margin-top: 0.781vw;
          }
          p {
            grid-area: brief;
            font-weight: 500;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .wrapper {
    background: var(--second-bg);
    display: flex;
    flex-direction: column;
    h1 {
      font-size: 2.2vw;
      line-height: 2.7vw;
      text-align: left;
      padding: 0;
      font-weight: 600;
    }
    h2 {
      font-size: 1.823vw;
      line-height: 2vw;
      font-weight: 600;
      color: var(--light-seven);
    }
    p {
      font-size: 1.693vw;
      line-height: 2.604vw;
      height: 6.766vw;
    }
    h3 {
      font-size: 1.823vw;
      line-height: 2vw;
      font-weight: 300;
    }
    .ipad-top {
      display: flex;
      justify-content: space-around;
      align-items: center;
      .ipad-left {
        width: 51.172vw;
        background: var(--content-bg);
        display: grid;
        grid-template-columns: auto;
        gap: 3vw;
        padding-bottom: 1.953vw;
        padding-top: 1.953vw;
        .ipad-content {
          display: grid;
          grid-template-columns: auto;
          gap: 1.2vw;
          padding-left: 1.953vw;
        }
        .border-container {
          width: 9.115vw;
          height: 0.26vw;
          background: white;
        }
      }
      .ipad-right {
        width: 27.604vw;
        .ipad-content {
          display: grid;
          grid-template-columns: auto;
          gap: 1vw;
          .img {
            width: 27.604vw;
            height: 20.703vw;
            display: flex;
            align-items: center;
          }
          h2 {
            color: var(--black-seven);
          }
          h1 {
            color: var(--black);
          }
          h3 {
            color: var(--black);
          }
          &:nth-child(1) {
            margin-bottom: 15.625vw;
          }
        }
      }
    }
    .ipad-bottom {
      width: 94vw;
      padding-top: 4.557vw;
      margin-left: auto;
      margin-right: auto;
      .ipad-bottom-cont {
        background: black;
        border-radius: 0.521vw;
        position: relative;
        .img {
          width: 100%;
          height: 31.641vw;
          opacity: 0.4;
        }
        .ipad-content {
          pointer-events: none;
          position: absolute;
          top: 10vw;
          left: 50%;
          transform: translateX(-50%);
          display: grid;
          grid-template-areas:
            "category time"
            "title title";
          gap: 1vw;
          h1 {
            text-align: center;
            grid-area: title;
          }
          h2 {
            grid-area: category;
            text-align: left;
          }
          h3 {
            grid-area: time;
            text-align: right;
          }
        }
      }
    }
  }
  .fourthMobile {
    display: none;
  }
}

@media screen and (max-width: 414px) {
  .wrapper {
    .fourthIpad {
      display: none;
    }
    .fourthMobile {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: var(--second-bg);
      padding-top: 9.333vw;
      padding-bottom: 6.933vw;
      h1 {
        font-size: 3.2vw;
        line-height: 4vw;
        font-weight: 600;
      }
      h2 {
        font-size: 2.667vw;
        line-height: 3.467vw;
        font-weight: 600;
      }
      h3 {
        font-size: 2.667vw;
        line-height: 3.467vw;
        font-weight: 300;
      }
      .mob-top {
        display: flex;
        flex-direction: row;
        justify-content: center;
        .img {
          width: 44.267vw;
          height: 33.333vw;
        }
        .mob-content {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          position: relative;
          text-align: left;
          width: 49.067vw;
          margin-left: 1.4vw;
          padding-right: 2.667vw;
          h2 {
            color: var(--black-seven);
          }
          h1 {
            color: var(--title-black);
          }
          h3 {
            color: var(--black-six);
            position: absolute;
            bottom: 0;
          }
        }
        &:nth-child(2) {
          margin-top: 5.333vw;
        }
        &:nth-child(5) {
          margin-top: 5.333vw;
        }
      }
      .mob-mid {
        width: 94vw;
        background: var(--content-bg);
        margin-top: 5.333vw;
        margin-bottom: 5.333vw;

        .mid-content {
          width: 72.8vw;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          justify-content: center;
          padding-left: 8vw;
          padding-top: 2.6vw;
          padding-right: 8vw;
          padding-bottom: 2.667vw;
          &:nth-child(1) {
            padding-top: 6.667vw;
          }
          &:last-child {
            padding-bottom: 6.667vw;
          }
          h2 {
            color: var(--light-seven);
          }
          h1 {
            color: var(--light);
          }
          h3 {
            color: var(--light-six);
            position: absolute;
            bottom: 0;
          }
        }
        .mob-border {
          width: 18.667vw;
          height: 0.8vw;
          background: var(--light);
        }
      }
    }
  }
}
</style>